import React from "react";
import Footer from "../components/Footer/Footer";
import ImgGallery from "../components/ImgGallery/ImgGallery";
import PageTop from "../components/PageTop/PageTop";
import TopNavigation from "../components/TopNavigation/TopNavigation";
import { animateScroll } from "react-scroll";
import { useEffect, useRef } from "react";
import BackToTopButton from "../components/BackToTopButton/BackToTopButton";

// import LocomotiveScroll from "locomotive-scroll";
// import "./locomotive.css";

const Gallery = () => {
  
  useEffect(() => {
    animateScroll.scrollToTop({
      duration: 500,
      smooth: "easeInOutQuart", 
    });
  }, []);

  // const scrollRef = useRef(null); 

  // useEffect(() => {
  //   const scroll = new LocomotiveScroll({
  //     el: scrollRef.current,
  //     smooth: true,
  //   });

  //   setTimeout(() => {
  //     scroll.update(); 
  //   }, 100);

  //   return () => {
  //     scroll.destroy(); 
  //   };
  // }, []);
    
  return (
    <>
    <div>
      <TopNavigation title="Talukder Group" />
      <PageTop pageTitle="Our Recent Events" />
      <ImgGallery />
      <Footer />
      <BackToTopButton /> 
      </div>
    </>
  );
};


export default Gallery;
